/**
 * Polyfill function that generates font weight CSS properties to an element using dynamic font
 * settings, with a fallback to the `font-weight` property.
 *
 * @param weight - The weight to apply.
 */ function fontWeight(weight) {
    return {
        fontVariationSettings: `"wght" ${weight}`,
        fontWeight: weight
    };
}

export { fontWeight };
//# sourceMappingURL=font-weight.js.map
